export default "__VITE_ASSET__Da6gAH0d__"